import Styles from "./MusicCard.module.module.scss";
import classnames from "classnames";

interface MusicCardTypes {
    title: string;
    subText: string;
    link: string;
    coverImage: string;
    layoutType?: "default" | "inline" | 'small_inline' | "banner" | "banner";
    acentColor?: string;
    onClick: (data: any) => void;
}

const MusicCard = ({ 
    title,
    subText,
    link,
    coverImage,
    layoutType="default",
    acentColor,
    onClick 
}: MusicCardTypes) => {

    const handleClick=()=>{
        onClick(link)
    }
    return (
        <div className={classnames(Styles[layoutType],Styles.container)} >
            <div className={Styles.cover_image} onClick={handleClick}>
                <img src={coverImage}/>
            </div>
            <div className={Styles.song_info} style={layoutType==="banner"?{background:`url("${link}") no-repeat`, backgroundPosition:"center",backgroundSize:"cover"}:{}} >
                <div className={Styles.name} onClick={handleClick}>{title}</div>
                <div className={Styles.desc} onClick={handleClick}>{subText}</div>
            </div>
        </div>
    )
}

export default MusicCard
